import React from 'react';

const ExclamacionIcon = () => {
    const icon = `<svg xmlns="http://www.w3.org/2000/svg" width="131" height="131" viewBox="0 0 131 131" >
                <g fill="none" fill-rule="evenodd" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5">
                    <path stroke="#333" d="M130 65.501C130 101.119 101.119 130 65.5 130S1 101.12 1 65.501C1 29.877 29.881 1 65.5 1S130 29.877 130 65.501z" />
                    <path stroke="#F5F5F5" d="M60.518 107A9.96 9.96 0 0 1 59 101.685C59 96.335 63.149 92 68.271 92c2.162 0 4.153.774 5.729 2.068M76 30H59l4.975 53" />
                    <path stroke="#333" d="M76 100.5a9.5 9.5 0 0 1-9.499 9.5A9.499 9.499 0 0 1 57 100.5a9.5 9.5 0 1 1 19 0zM75 28H56l5.068 55h8.866z" />
                </g>
            </svg>`;
    
    return (
        <span dangerouslySetInnerHTML={{__html: icon}}></span>
    )     
}

export default ExclamacionIcon;